export default {"src":"/_next/static/media/clock.8f7238f5.svg","height":120,"width":114,"blurWidth":0,"blurHeight":0};